export enum ReportsScope {
  Yours = "yours",
  Groups = "groups",
  Conversations = "conversations",
  Advisers = "advisers",
  Org = "org"
}
